module.exports = __webpack_public_path__ + "img/new-tsgn_tab4.f8997270.png";